import * as angular from 'angular';
import { ResponsiveViewService } from './responsive-view.service';

export const responsiveViewModule = angular.module('go.responsiveView', [])
	.service(ResponsiveViewService.NG1_INJECTION_NAME, ResponsiveViewService)
	.name;
